import App from "../app";
import { InitializeEvent, StartEvent } from "../events";
import { OverviewScore } from "../model/datasource/score";
import Controller from "./controller";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";

export class InitOverviewController<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends Controller<P, A, Z, I> {
	bind(target: EventTarget, app: App<P, A, Z, I>): void {
		target.addEventListener(InitializeEvent.type, () => this.init(app));
		target.addEventListener(StartEvent.type, (e: StartEvent) => this.start(app, e.detail));
	}

	init(app: App<P, A, Z, I>): void {
		app.view.init(app);
		Promise.all([
			app.model.metadata.getProductId(),
			app.model.score.getOverviewScores()
		]).then((result: [P, OverviewScore<A, Z>[]]) => ({
			product: result[0],
			scores: result[1]
		})).then((result: { product: P; scores: OverviewScore<A, Z>[] }) => {
			app.view.summary.displayTable(
				app.view.chart.getOverviewSummaryTable(app.getJquery()),
				result.product
			);
			app.view.sections.displayOverviewScores(
				app.view.chart.getOverviewScoreChart(),
				result.scores
			)
		});
	}

	start(app: App<P, A, Z, I>, element: HTMLElement): void {
		app.view.sections.toggleStart(element);
	}
}